import firebase from '../config'
import React,{Component} from 'react'

export default class Filter extends Component{
      componentDidMount(){
        this.fun();
      }

      util1(e,ref1,type){
          var obj =[]
        return new Promise((resolve) =>{
            ref1.collection(e).get().then(doc =>{
                doc.forEach((d)=>{
                    if(d.id !== "details"){
                        var o = d.data();
                        o["type"] = type
                        o["category"] = e; 
                        o["id"] = d.id;
                        obj.push({name:o.name,data:o})
                        
                    }

                 })
                resolve(obj)
           })
        })
    }

    util2(){
      var obj = [];
      return new Promise(resolve =>{
          firebase.firestore().collection('tests').get().then((snap) =>{
          snap.forEach(doc => {
            if(doc.id !== "habits" && doc.id !== "health_risk"){
                var o = doc.data();
                o["type"] = null
                o["category"] = null
                o["id"] = doc.id;
                obj.push({name:o.name,data:o})
            }
          })
          resolve(obj);
        })
      })
    }
      fun(){
        const db = firebase.firestore();
        const ref = db.collection('tests').doc('habits');
        const ref1 = db.collection('tests').doc('health_risk');
        let temp = [];
        const getSubCollections = firebase
        .functions()
        .httpsCallable('getSubCollections');
        var res = {};

        getSubCollections({ docPath: 'tests/habits' })
        .then(async (result) => {
          var collections = result.data.collections;
          
        collections.forEach(e =>{
            this.util1(e,ref,"habits").then(obj =>{
                obj.forEach(doc =>{
                    res[doc.name] = doc.data
                })
            })
        })
        })
        .catch(function(error) {
          // Getting the Error details.
          var code = error.code;
          var message = error.message;
          var details = error.details;
          console.log(code,message,details)
          // ...
        });

        getSubCollections({ docPath: 'tests/health_risk' })
        .then(async (result) => {
          var collections = result.data.collections;
          
        collections.forEach(e =>{
            this.util1(e,ref1,'health_risk').then(obj =>{
                obj.forEach(doc =>{
                    res[doc.name] = doc.data
                })

            })
        })
        this.util2().then(obj =>{
          obj.forEach(doc =>{
            res[doc.name] = doc.data

          })
          setTimeout(()=>{
            console.log(res)
            console.log(res)
            for(let key in res){
              firebase.firestore().collection('search').doc(key).set(res[key])
            }
        },5000)
      })

        })
        .catch(function(error) {
          // Getting the Error details.
          var code = error.code;
          var message = error.message;
          var details = error.details;
          console.log(code,message,details)
          // ...
        });
        
      }

      fun2 = () =>{
        const getSubCollections = firebase
        .functions()
        .httpsCallable('getSubCollections');
        getSubCollections({ docPath: 'tests/habits' })
        .then(async (result) => {
          var collections = result.data.collections;
          collections.forEach(e =>{
            firebase.firestore().collection('tests').doc('habits').collection(e).doc('details').set({name:e,data:`${e} + habit`})

          })

        })
      }
      render(){
        return <h1>DONE</h1>
      }
    
  }

